// @ts-nocheck
import React, { Fragment } from 'react';
import Modal from 'react-bootstrap/Modal';

function NtxCustomModal({
  width,
  show,
  setShow,
  title = '',
  children,
  bodyClassName = '',
  headerClassName = '',
  showHeader = true,
  centered = false
}) {
  const handleClose = () => {
    setShow(false); // Allow closing the modal
  };

  return (
    <Fragment>
      <Modal
        style={{ maxWidth: width }}
        aria-labelledby='neatix-modal-title'
        dialogClassName='modal-width'
        show={show}
        centered={centered}
        onHide={handleClose}
      >
        {showHeader && (
          <Modal.Header closeButton className={headerClassName}>
            <Modal.Title id='neatix-modal-title'>{title}</Modal.Title>
          </Modal.Header>
        )}

        <Modal.Body className={bodyClassName}>{children}</Modal.Body>
      </Modal>
      <style>
        {`
          .modal-width {
            max-width: ${width || '90%'} ;
            }
        `}
      </style>
    </Fragment>
  );
}

export default NtxCustomModal;
